export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7622.000dbfc9.jpg";